/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const COMMUNITY_ICON = "https://media.werz.at/community-assets/fourplay/community-icon.jpg"

const FOUR_PLAY: CommunityData = {
  code: "fourplay",
  inviteCode: "fourplay",
  name: "Four Play",
  thumbnail: COMMUNITY_ICON,
  favicon: COMMUNITY_ICON,
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/fpl-030`,
  waitlist: true,
  publicEventPages: false,
  socials: {},
  styles: {
    global: {
      counterColor: "",
      logo: { src: COMMUNITY_ICON, styles: "w-[96px] h-[96px] object-contain" },
      alternativeLogo: { src: COMMUNITY_ICON, styles: "w-[96px] h-[96px] object-contain" },
      modalWindow: { container: "", title: "", subtitle: "" },
      bgColor: "",
      asideBg: "",
      asideStyles: "",
      contentBg: "",
      contentBoxShadow: "",
      bgDesktop: "",
      bgMobile: "",
      nonMemberBg: "",
      mainFont: "",
      primaryButton: "",
    },
    navigation: {
      iconsColor: "",
      sideBarSeparator: "",
      separator: "",
      item: "",
      itemSelected: "",
    },
    communityLanding: {
      titles: "",
      emptyOrLoadingState: "",
      shop: { title: "", text: "" },
    },
  },
}

export default FOUR_PLAY
